import { createContext, useState, useContext, useEffect } from 'react';
import instance from '../Utils/api';

// Create the context
const MainContext = createContext();

// Create a provider component
export const ContextProvider = ({ children }) => {
    const [openLoginDialog, setOpenLoginDialog] = useState(false); // Login modal state
    const [openRegisterDialog, setOpenRegisterDialog] = useState(false); // Register modal state
    const [currentTabIndex, setCurrentTabIndex] = useState(0);
    const [userName, setUserName] = useState();
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');
    const [userDisplay, setUserDisplay] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [openviewDialog, setopenviewDialog] = useState(false);
    const [openviewCancelDialog, setopenviewCancelDialog] = useState(false);
    const [deleteDialog, setdeleteDialog] = useState(false);
    const [statusDialog, setstatusDialog] = useState(false);
    const [commonDialog, setCommonDialog] = useState(false)
    const [imageDialog, setImageDialog] = useState(false)
    const [edit, setEdit] = useState(false);
    const [cartItem, SetCartItem] = useState(false)
    const [openConsultationDialog, setOpenConsultationDialog] = useState(false)
    const [loading, setLoading] = useState(false);
    const [cartLength, setCartLength] = useState(0);

    const customerData = async () => {
        try {
            const response = await instance.get('Customer/getCustomerById');
            setUserName(response.data.data);
        }
        catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        if (userDisplay === true || token && role == 'Customer') {
            customerData();
        }
    }, [userDisplay, token, role])


    const fetchCartLength = async () => {
        try {
            const response = await instance.get("/Cart/getCart");
            const items = response?.data?.data?.items || [];
            setCartLength(items?.length);
        } catch (error) {
            console.error("Error fetching cart length:", error);
        }
    };

    // Update cart length when `cartItem` changes
    useEffect(() => {
        if (cartItem && token) {
            fetchCartLength();
            SetCartItem(false); // Reset the flag after successful update
        }
    }, [cartItem]);
    useEffect(() => {
        if (token) {
            fetchCartLength();
        }
    }, [])

    return (
        <MainContext.Provider value={{ openviewCancelDialog, setopenviewCancelDialog, imageDialog, setImageDialog, openConsultationDialog, setOpenConsultationDialog, setUserDisplay, userName, openLoginDialog, setOpenLoginDialog, openRegisterDialog, setOpenRegisterDialog, currentTabIndex, setCurrentTabIndex, openDialog, setOpenDialog, openviewDialog, setopenviewDialog, loading, setLoading, deleteDialog, setdeleteDialog, setstatusDialog, statusDialog, edit, setEdit, setCommonDialog, commonDialog, cartLength, fetchCartLength, cartItem, SetCartItem }}>
            {children}
        </MainContext.Provider>
    );
};

// Custom hook to use the buttondisable context
export const useGlobalContext = () => useContext(MainContext);
